import { useEffect, useRef } from 'react';
/**
 * useOnClickOutside
 *
 * Determine when the user clicks outside of a target element.
 *
 * @example
 *
 *
 * function onClickOutside(e) {
 *   console.log('The user clicked outside')
 * }
 *
 * const { bind } = useOnClickOutside(onClickOutside, {
 *   enabled: true
 * })
 *
 * <Button {...bind}>Button</Button>
 */

export function useOnClickOutside(handler) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$enabled = _ref.enabled,
      enabled = _ref$enabled === void 0 ? true : _ref$enabled;

  var onClickInsideRef = useRef(false);
  var handlerRef = useRef(handler); // Since we only want the `useEffect` to run when enabled
  // actually changes, we update and access our event
  // handler in a ref.

  useEffect(function () {
    handlerRef.current = handler;
  });
  useEffect(function () {
    if (!enabled) {
      onClickInsideRef.current = false;
      return;
    }

    function onClick(e) {
      if (onClickInsideRef.current) {
        onClickInsideRef.current = false;
        return;
      }

      handlerRef.current(e);
    }

    document.addEventListener('mousedown', onClick); // eslint-disable-next-line consistent-return

    return function () {
      document.removeEventListener('mousedown', onClick);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled]);
  return {
    bind: {
      onMouseDownCapture: enabled ? function () {
        onClickInsideRef.current = true;
      } : null
    }
  };
}